(() => {
  const gallerySelector = '[class*="ai-photo-carousel__image-"]';

  function initialiseInstallationGallery() {
    const images = Array.from(document.querySelectorAll(gallerySelector));
    if (!images.length || document.querySelector('.dac-lightbox')) return;

    images.forEach((image, index) => {
      const description = image.parentElement?.querySelector('[class*="ai-photo-carousel__description-"]')?.textContent?.trim();
      if (!image.alt) image.alt = description || `Recent Discount Air Conditioning installation ${index + 1}`;
      const trigger = image.closest('[class*="ai-photo-carousel__link-"]');
      if (trigger && trigger.tagName !== 'A') {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('tabindex', '0');
        trigger.setAttribute('aria-label', `Enlarge: ${image.alt}`);
      }
    });

    const modal = document.createElement('div');
    modal.className = 'dac-lightbox';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Recent installation image viewer');
    modal.innerHTML = `
      <button class="dac-lightbox__close" type="button" aria-label="Close image viewer">&times;</button>
      <button class="dac-lightbox__nav dac-lightbox__prev" type="button" aria-label="Previous installation">&#8249;</button>
      <figure class="dac-lightbox__figure">
        <img class="dac-lightbox__image" alt="">
        <figcaption class="dac-lightbox__caption"></figcaption>
      </figure>
      <button class="dac-lightbox__nav dac-lightbox__next" type="button" aria-label="Next installation">&#8250;</button>`;
    document.body.appendChild(modal);

    const modalImage = modal.querySelector('.dac-lightbox__image');
    const caption = modal.querySelector('.dac-lightbox__caption');
    const closeButton = modal.querySelector('.dac-lightbox__close');
    let currentIndex = 0;
    let previousFocus = null;

    const render = () => {
      const source = images[currentIndex];
      modalImage.src = source.currentSrc || source.src;
      modalImage.alt = source.alt;
      caption.textContent = source.alt;
    };

    const open = (index, trigger) => {
      currentIndex = index;
      previousFocus = trigger;
      render();
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    };

    const close = () => {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      previousFocus?.focus?.();
    };

    const move = direction => {
      currentIndex = (currentIndex + direction + images.length) % images.length;
      render();
    };

    images.forEach((image, index) => {
      const trigger = image.closest('[class*="ai-photo-carousel__link-"]') || image;
      trigger.addEventListener('click', event => {
        if (trigger.tagName === 'A' && trigger.getAttribute('href')) return;
        event.preventDefault();
        open(index, trigger);
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(index, trigger);
        }
      });
    });

    closeButton.addEventListener('click', close);
    modal.querySelector('.dac-lightbox__prev').addEventListener('click', () => move(-1));
    modal.querySelector('.dac-lightbox__next').addEventListener('click', () => move(1));
    modal.addEventListener('click', event => { if (event.target === modal) close(); });
    document.addEventListener('keydown', event => {
      if (!modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseInstallationGallery, { once: true });
  } else {
    initialiseInstallationGallery();
  }
})();
